import { createAction, createAsyncAction } from "typesafe-actions";
import { VideoState, YoukuVideo, StudyVideo } from "../types";

// api
export const initServer = createAction("INIT_SERVER", (action) => {
  return (msg: string) => action({ msg: msg });
});

export const fetchDemoVideo = createAction("FETCH_DEMOVIDEO", (action) => {
  return (payload: VideoState) => action(payload);
});

export const fetchYoukuVideo = createAction("FETCH_YOUKUVIDEO", (action) => {
  return (payload: YoukuVideo) => action(payload);
});

export const fetchStudyVideo = createAction("FETCH_STUDYVIDEO", (action) => {
  return (payload: StudyVideo) => action(payload);
})

export const fetchDemoVideoAsync = createAsyncAction(
  "FETCH_DEMOVIDEO_REQUEST",
  "FETCH_DEMOVIDEO_SUCCESS",
  "FETCH_DEMOVIDEO_FAILURE"
)<string, VideoState, Error>();
